module.exports = __webpack_public_path__ + "images/footer_fukidashi_pc_7f0552829645fec8356795478283b8b8.png";